import React, { ComponentProps } from "react";

type CtaButtonBgIconProps = ComponentProps<"svg"> & {
  size?: "sm" | "md" | "lg";
};

function BgSmall({ fill, ...props }: ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 96 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      {...props}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H84C90.6274 0 96 5.37258 96 12V28C96 34.6274 90.6274 40 84 40H12C5.37258 40 0 34.6274 0 28V12Z"
        fill={fill}
      />
      <g filter="url(#filter0_d_5942_5981)">
        <mask id="path-2-inside-1_5942_5981" fill="white">
          <path d="M0 21.5C0 19.1774 0 18.0161 0.16028 17.0453C0.997707 11.973 4.97303 7.99771 10.0453 7.16028C11.0161 7 12.1774 7 14.5 7H81.5C83.8226 7 84.9839 7 85.9547 7.16028C91.027 7.99771 95.0023 11.973 95.8397 17.0453C96 18.0161 96 19.1774 96 21.5C96 23.8226 96 24.9839 95.8397 25.9547C95.0023 31.027 91.027 35.0023 85.9547 35.8397C84.9839 36 83.8226 36 81.5 36H14.5C12.1774 36 11.0161 36 10.0453 35.8397C4.97303 35.0023 0.997707 31.027 0.16028 25.9547C0 24.9839 0 23.8226 0 21.5Z" />
        </mask>
        <path
          d="M0 21.5C0 19.1774 0 18.0161 0.16028 17.0453C0.997707 11.973 4.97303 7.99771 10.0453 7.16028C11.0161 7 12.1774 7 14.5 7H81.5C83.8226 7 84.9839 7 85.9547 7.16028C91.027 7.99771 95.0023 11.973 95.8397 17.0453C96 18.0161 96 19.1774 96 21.5C96 23.8226 96 24.9839 95.8397 25.9547C95.0023 31.027 91.027 35.0023 85.9547 35.8397C84.9839 36 83.8226 36 81.5 36H14.5C12.1774 36 11.0161 36 10.0453 35.8397C4.97303 35.0023 0.997707 31.027 0.16028 25.9547C0 24.9839 0 23.8226 0 21.5Z"
          fill={fill}
        />
        <path
          d="M0 7H96H0M96 24C96 32.2843 89.2843 39 81 39H15C6.71573 39 0 32.2843 0 24C0 28.9706 5.37258 33 12 33H84C90.6274 33 96 28.9706 96 24ZM96 24M0 36V7V36M0 36M96 7V36V7"
          fill="url(#paint0_linear_5942_5981)"
          fillOpacity="0.08"
          mask="url(#path-2-inside-1_5942_5981)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5942_5981"
          x="0"
          y="7"
          width="96"
          height="33"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5942_5981"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5942_5981"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_5942_5981"
          x1="48"
          y1="7"
          x2="48"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.288462" stopColor="white" stopOpacity="0" />
          <stop offset="0.641666" stopColor="white" stopOpacity="0" />
          <stop offset="0.956666" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function BgMedium({ fill, ...props }: ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 200 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      {...props}
    >
      {/* Primary Background Layer */}
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0H184C192.837 0 200 7.16344 200 16V32C200 40.8366 192.837 48 184 48H16C7.16344 48 0 40.8366 0 32V16Z"
        fill={fill}
      />

      {/* Gloss/Shadow Effect Group */}
      <g filter="url(#filter0_d_6858_1769)">
        <mask id="path-2-inside-1_6858_1769" fill="white">
          <path d="M0 25.5C0 23.178 0 22.017 0.120327 21.0414C1.01872 13.7575 6.75747 8.01872 14.0414 7.12033C15.017 7 16.178 7 18.5 7H181.5C183.822 7 184.983 7 185.959 7.12033C193.243 8.01872 198.981 13.7575 199.88 21.0414C200 22.017 200 23.178 200 25.5C200 27.822 200 28.983 199.88 29.9586C198.981 37.2425 193.243 42.9813 185.959 43.8797C184.983 44 183.822 44 181.5 44H18.5C16.178 44 15.017 44 14.0414 43.8797C6.75747 42.9813 1.01872 37.2425 0.120327 29.9586C0 28.983 0 27.822 0 25.5Z" />
        </mask>
        <path
          d="M0 25.5C0 23.178 0 22.017 0.120327 21.0414C1.01872 13.7575 6.75747 8.01872 14.0414 7.12033C15.017 7 16.178 7 18.5 7H181.5C183.822 7 184.983 7 185.959 7.12033C193.243 8.01872 198.981 13.7575 199.88 21.0414C200 22.017 200 23.178 200 25.5C200 27.822 200 28.983 199.88 29.9586C198.981 37.2425 193.243 42.9813 185.959 43.8797C184.983 44 183.822 44 181.5 44H18.5C16.178 44 15.017 44 14.0414 43.8797C6.75747 42.9813 1.01872 37.2425 0.120327 29.9586C0 28.983 0 27.822 0 25.5Z"
          fill={fill}
        />
        <path
          d="M0 7H200H0M200 28C200 38.4934 191.493 47 181 47H19C8.50659 47 0 38.4934 0 28C0 35.1797 7.16344 41 16 41H184C192.837 41 200 35.1797 200 28ZM200 28M0 44V7V44M0 44M200 7V44V7"
          fill="url(#paint0_linear_6858_1769)"
          fillOpacity="0.08"
          mask="url(#path-2-inside-1_6858_1769)"
        />
      </g>

      <defs>
        <filter
          id="filter0_d_6858_1769"
          x="0"
          y="7"
          width="200"
          height="41"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6858_1769"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6858_1769"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6858_1769"
          x1="100"
          y1="7"
          x2="100"
          y2="44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.288462" stopColor="white" stopOpacity="0" />
          <stop offset="0.641666" stopColor="white" stopOpacity="0" />
          <stop offset="0.956666" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function BgLarge({ fill, ...props }: ComponentProps<"svg">) {
  return (
    <svg
      viewBox="0 0 343 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      {...props}
    >
      {/* Primary Background Layer */}
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0H327C335.837 0 343 7.16344 343 16V32C343 40.8366 335.837 48 327 48H16C7.16345 48 0 40.8366 0 32V16Z"
        fill={fill}
      />

      {/* Gloss/Shadow Effect Group */}
      <g filter="url(#filter0_d_6725_11061)">
        <mask id="path-2-inside-1_6725_11061" fill="white">
          <path d="M0 25.5C0 23.178 0 22.017 0.120327 21.0414C1.01872 13.7575 6.75747 8.01872 14.0414 7.12033C15.017 7 16.178 7 18.5 7H324.5C326.822 7 327.983 7 328.959 7.12033C336.243 8.01872 341.981 13.7575 342.88 21.0414C343 22.017 343 23.178 343 25.5C343 27.822 343 28.983 342.88 29.9586C341.981 37.2425 336.243 42.9813 328.959 43.8797C327.983 44 326.822 44 324.5 44H18.5C16.178 44 15.017 44 14.0414 43.8797C6.75747 42.9813 1.01872 37.2425 0.120327 29.9586C0 28.983 0 27.822 0 25.5Z" />
        </mask>
        <path
          d="M0 25.5C0 23.178 0 22.017 0.120327 21.0414C1.01872 13.7575 6.75747 8.01872 14.0414 7.12033C15.017 7 16.178 7 18.5 7H324.5C326.822 7 327.983 7 328.959 7.12033C336.243 8.01872 341.981 13.7575 342.88 21.0414C343 22.017 343 23.178 343 25.5C343 27.822 343 28.983 342.88 29.9586C341.981 37.2425 336.243 42.9813 328.959 43.8797C327.983 44 326.822 44 324.5 44H18.5C16.178 44 15.017 44 14.0414 43.8797C6.75747 42.9813 1.01872 37.2425 0.120327 29.9586C0 28.983 0 27.822 0 25.5Z"
          fill={fill}
        />
        <path
          d="M0 7H343H0ZM343 28C343 38.4934 334.493 47 324 47H19C8.50659 47 0 38.4934 0 28C0 35.1797 7.16344 41 16 41H327C335.837 41 343 35.1797 343 28ZM0 44V7V44ZM343 7V44V7Z"
          fill="url(#paint0_linear_6725_11061)"
          fillOpacity="0.08"
          mask="url(#path-2-inside-1_6725_11061)"
        />
      </g>

      <defs>
        <filter
          id="filter0_d_6725_11061"
          x="0"
          y="7"
          width="343"
          height="41"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6725_11061"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6725_11061"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6725_11061"
          x1="171.5"
          y1="7"
          x2="171.5"
          y2="44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.5" />
          <stop offset="0.288462" stopColor="white" stopOpacity="0" />
          <stop offset="0.641666" stopColor="white" stopOpacity="0" />
          <stop offset="0.956666" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
}

/**
 * Each one has its own viewBox + path geometry so the curves render correctly.
 */
export default function CtaButtonBgIcon({
  size = "md",
  ...props
}: CtaButtonBgIconProps) {
  switch (size) {
    case "sm":
      return <BgSmall {...props} />;
    case "lg":
      return <BgLarge {...props} />;
    default:
      return <BgMedium {...props} />;
  }
}
